export default "__VITE_ASSET__ee2aeef2__"